<template>
  <hm-content :title="opreateMode + '商品'">
    <el-form :model="ruleForm"
             :rules="rules"
             ref="ruleForm"
             label-width="100px"
             class="product-ruleForm">
      <el-form-item label="商品分类："
                    prop="categoryId">
        <el-select clearable
                   v-model="ruleForm.categoryId"
                   placeholder="选择分类"
                   size="small"
                   filterable
                   class="mr10">
          <el-option v-for="item in categoryList.list"
                     :key="item.id"
                     :label="item.categoryName"
                     :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商品类型：">
        <el-radio-group v-model="ruleForm.productType"
                        size="small">
          <el-radio :label="1">服务商品</el-radio>
          <el-radio :label="2">实物商品</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="商品名称："
                    prop="productName">
        <el-input size="small"
                  clearable
                  class="mr10 ipt"
                  v-model.trim="ruleForm.productName"
                  placeholder="请输入商品名称"></el-input>
      </el-form-item>
      <el-form-item label="商品售价："
                    prop="price">
        <el-input size="small"
                  clearable
                  @mousewheel.prevent.native
                  type="number"
                  v-model.trim="ruleForm.price"
                  class="mr10 ipt"></el-input>元
      </el-form-item>
      <el-form-item label="会员售价："
                    prop="memberPrice">
        <el-input size="small"
                  clearable
                  @mousewheel.prevent.native
                  type="number"
                  v-model.trim="ruleForm.memberPrice"
                  class="mr10 ipt"></el-input>元
      </el-form-item>
      <el-form-item label="主图："
                    prop="listHeader">
        <my-upload field="file"
                   @crop-success="cropSuccess"
                   @crop-upload-success="cropUploadSuccess"
                   @crop-upload-fail="cropUploadFail"
                   v-model="show"
                   noCircle
                   noSquare
                   :width="345"
                   :height="180"
                :headers="{ 'X-Access-Token': $token }"
                :params="{ fileDir: 'mallDecoration' }"
                :url="$uploadUrl"
                   img-format="png"></my-upload>
        <el-button type="primary"
                   size="small"
                   v-show="!listHeaderImgUrl"
                   @click="toggleShow">上传</el-button>
        <span class="form-tip">（主图仅可设置一张，图片尺寸建议345x180）</span>
        <div class="priview"
             v-if="listHeaderImgUrl">
          <img :src="listHeaderImgUrl"
               alt="主图">
          <div class="opreat-wrapper flex item-center flex-center">
            <el-button type="text"
                       @click="deleteListHeader">删除</el-button>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="商品状态：">
        <div class="flex item-center">
          <el-switch style="display: block"
                     v-model="ruleForm.status"
            active-color="#13ce66"
                     inactive-color="#ff4949"
                     active-text="上架"
                     inactive-text="下架"
                     :active-value="1"
                     :inactive-value="0"></el-switch>
          <span class="form-tip">（关闭后，不出现在服务内）</span>
        </div>
      </el-form-item>
      <div class="flex flex-center">
        <el-button type="primary"
                   size="small"
                   @click="submitForm('ruleForm')">提交</el-button>
        <el-button size="small"
                   @click="$router.back(-1)">返回</el-button>
      </div>
    </el-form>

  </hm-content>
</template>

<script>
 
import { mapGetters } from "vuex";
import myUpload from "vue-image-crop-upload";

 export default {
  components: {   myUpload },
  data() {
    const patternPrice = function(rule, val, callback) {
      if (this.ruleForm.price && this.ruleForm.price > 0) {
        const isFloat = String(this.ruleForm.price).indexOf(".") > -1;
        if (
          Number.isInteger(+this.ruleForm.price) ||
          (isFloat && String(this.ruleForm.price).split(".")[1].length <= 2)
        ) {
          callback();
        } else {
          return callback(new Error("售价最多保留两位小数"));
        }
      } else {
        return callback(new Error("请输入售价，且售价应大于0"));
      }
    }.bind(this);
    const patternMemberPrice = function(rule, val, callback) {
      if (val && val >= 0) {
        const isFloat = String(val).indexOf(".") > -1;
        if (
          (Number.isInteger(+val) ||
            (isFloat && String(val).split(".")[1].length <= 2)) &&
          +val <= +this.ruleForm.price
        ) {
          callback();
        } else {
          return callback(
            new Error("会员价最多保留两位小数,且应小于或等于商品售价")
          );
        }
      } else {
        return callback(new Error("请输入会员价，且会员价应大于或等于0"));
      }
    }.bind(this);
    const patternListHeader = function(rule, val, callback) {
      if (!this.listHeaderImgUrl) {
        return callback(new Error("请上传主图"));
      }
      callback();
    }.bind(this);
    return {
      opreateMode: "新增",
      showDetail: false,
      show: false,
      inputVisible: false,
      isMininum: true,
      inputValue: "",
      activeTab: 0,
      type: 0,
      uploadedDetailList: [],
      listHeaderImgUrl: "",
      storeId: "",
      startDate: "",
      validDate: "",
      endDate: "",
      editorOption: {},
      chargeType: "",
      ruleForm: {
        categoryId: "",
        productTags: [],
        serverId: "",
        productName: "",
        productType: 1,
        validType: 1,
        recommendStatus: 0,
        status: 1,
        totTime: "",
        useTime: "",
        specification: "",
        price: "",
        validDay: "",
        validSpaceDay: "",
        dateAndTime: "",
        imgTxt: "",
        memberPrice: ""
      },
      rules: {
        categoryId: {
          required: true,
          message: "请选择商品分类",
          trigger: "change"
        },
        memberPrice: [
          { required: true, validator: patternMemberPrice, trigger: "blur" }
        ],
        imgTxt: [
          { required: true, message: "请输入图文详情", trigger: "blur" }
        ],
        serverId: [
          { required: true, message: "请选择服务", trigger: "change" }
        ],
        productName: [
          { required: true, message: "请输入商品名", trigger: "blur" }
        ],
        price: [{ required: true, validator: patternPrice, trigger: "blur" }],
        listHeader: [
          {
            required: true,
            validator: patternListHeader,
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: mapGetters(["categoryList", "rowProduct"]),
  watch: {
    rowProduct(v) {
      if (v) {
        for (let key in v) {
          if (this.ruleForm.hasOwnProperty(key)) {
            this.ruleForm[key] = v[key];
          }
        }
        this.goodsName = v.productName;
        this.listHeaderImgUrl = v.listImg;
      }
    }
  },
  mounted() {
    this.$store.dispatch("queryCategoryList", {
      pageSize: 999
    });
    this.$store.dispatch("queryRowProduct", {
      id: this.$route.query.id
    });
  },
  methods: {
    toggleShow() {
      this.show = !this.show;
    },
    cropSuccess() {},
    /**
     * upload success
     *
     * [param] jsonData   服务器返回数据，已进行json转码
     * [param] field
     */
    cropUploadSuccess(jsonData) {
      if (this.show) {
        this.listHeaderImgUrl = jsonData.result;
      } else if (this.showDetail) {
        this.uploadedDetailList.push(jsonData.result);
      }
    },
    cropUploadFail() {},
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = this.ruleForm;
          params = Object.assign(params, {
            id: this.$route.query.id,
            detailImg: this.uploadedDetailList.join(","),
            listImg: this.listHeaderImgUrl,
            validStartDate: this.ruleForm.validType === 2 ? this.startDate : "",
            validEndDate: this.ruleForm.validType === 2 ? this.endDate : ""
          });
          this.$store.dispatch("editProduct", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.$router.back(-1);
            }
          });
        }
      });
    },
    deleteListHeader() {
      this.listHeaderImgUrl = "";
    }
  }
};
</script>

<style scoped lang="scss">
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.priview {
  position: relative;
  width: 375px;
  height: 178px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}

.preview-wrapper {
  position: fixed;
  top: 100px;
  right: 30px;
  width: 365px;
  z-index: 10;
}
</style>
